import FbButton from 'components/FbUI/FbButton'

interface Props {
  onAccept: () => void
  onReject: () => void
  disabled: boolean
}

/**
 * Sticky bottom action bar on MobileSampleDetailPage when status=pending_review
 * and the viewer can review (admin or assigned RSM — derived from order.can_review).
 *
 * Presentational only — parent owns sheet state, sheet owns mutation.
 */
export function ReviewActionBar({ onAccept, onReject, disabled }: Props) {
  return (
    <div
      className="sticky bottom-0 left-0 right-0 z-10 flex gap-2 border-t border-line bg-surface px-4 py-3"
      role="region"
      aria-label="Review actions"
    >
      <FbButton
        type="button"
        variant="danger-outline"
        onClick={onReject}
        disabled={disabled}
        className="flex-1"
        size="lg"
      >
        Reject
      </FbButton>
      <FbButton
        type="button"
        variant="primary"
        onClick={onAccept}
        disabled={disabled}
        className="flex-1"
        size="lg"
      >
        Accept
      </FbButton>
    </div>
  )
}
